export const CHANGELOG = [
    {
        version: "v0.3.0",
        items: [
            "Sign-in asks for an authenticator code. Backup codes work if the device is unavailable.",
            "The About page has a practice patient. You pick that patient from a list of one, chart an examination, and then see the same charts and statistics as a saved examination. Nothing is stored.",
            "The tour can be started from Overview. It continues through the examinations table and the patients table.",
            "Creating a user explains the selected role. Creating a patient explains which fields are required."
        ]
    }
];

const SEEN_VERSION_KEY = "perioSeenVersion";

const parseVersion = (value) =>
    String(value || "")
        .replace(/^v/i, "")
        .split(".")
        .map((part) => parseInt(part, 10) || 0);

export const versionNewerThan = (version, than) => {
    if (!than) return true;

    const left = parseVersion(version);
    const right = parseVersion(than);
    const length = Math.max(left.length, right.length);

    for (let index = 0; index < length; index += 1) {
        const difference = (left[index] || 0) - (right[index] || 0);
        if (difference !== 0) return difference > 0;
    }

    return false;
};

export const unseenChangelogEntries = (seenVersion, currentVersion) => {
    if (!currentVersion || seenVersion === currentVersion) return [];

    const listed = CHANGELOG.filter((entry) => versionNewerThan(entry.version, seenVersion) && !versionNewerThan(entry.version, currentVersion));
    if (listed.length > 0) return listed;

    return [{ version: currentVersion, items: ["This version is now installed."] }];
};

export const formatChangelogMessage = (entries) =>
    entries.map((entry) => `${entry.version}\n${entry.items.map((item) => `• ${item}`).join("\n")}`).join("\n\n");

export const readSeenVersion = () => {
    try {
        return window.localStorage.getItem(SEEN_VERSION_KEY);
    } catch (error) {
        return null;
    }
};

export const rememberSeenVersion = (version) => {
    try {
        window.localStorage.setItem(SEEN_VERSION_KEY, version);
    } catch (error) {
        // The modal can show again next time if storage is unavailable.
    }
};
